/**
 * @param {any} doc 
 * @param {ImageBase64WithDimensions[]} attachedImages 
 */
export const appendImages = (doc, attachedImages) => {
  attachedImages.forEach(img => appendImage(doc, img))
}

export const nPixelsInCm = 5

/**
 * @param {any} doc 
 * @param {ImageBase64WithDimensions} img 
 */
export const appendImage = (doc, img) => {
  let pageW = 297
  let pageH = 210
  let w = img.width / nPixelsInCm
  let h = img.height / nPixelsInCm
  while (w > pageW || h > pageH) {
    w /= 1.001
    h /= 1.001
  }
  doc.addPage()
  doc.addImage(img.base64, 'JPG', pageW / 2 - w / 2, pageH / 2 - h / 2, w, h, '', 'FAST')
}